(function () {
  var rows = [];
  var target = 0;    // mål-progress (från scroll)
  var current = 0;   // eased progress
  var lerp = 0.1;    // 0.05 = mjukare/mer släp, 0.2 = snabbare/stramare
  var rafId = null;

  function collectRows() {
    rows = [];
    document.querySelectorAll("marquee-component").forEach(function (component) {
      var speedFactor = parseFloat(component.dataset.speedFactor || "20");
      component.querySelectorAll(".marquee-row").forEach(function (row) {
        var wrapper = row.querySelector(".marquee__wrapper");
        if (!wrapper) return;
        var dir = (row.dataset.direction || "normal") === "reverse" ? 1 : -1;
        rows.push({ wrapper: wrapper, distance: dir * speedFactor });
      });
    });
  }

  function getProgress() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (max <= 0) return 0;
    return Math.min(1, Math.max(0, window.scrollY / max));
  }

  function render(p) {
    for (var i = 0; i < rows.length; i++) {
      rows[i].wrapper.style.transform = "translateX(" + (p * rows[i].distance) + "%)";
    }
  }

  function loop() {
    current += (target - current) * lerp;
    if (Math.abs(target - current) < 0.0001) {  // nära nog — stanna loopen
      current = target;
      render(current);
      rafId = null;
      return;
    }
    render(current);
    rafId = requestAnimationFrame(loop);
  }

  function startLoop() {
    if (rafId == null) rafId = requestAnimationFrame(loop);
  }

  function onScroll(e) {
    target = (e && typeof e.progress === "number") ? e.progress : getProgress();
    startLoop();
  }

  function setup() {
    collectRows();
    target = current = getProgress();
    render(current);
  }

  // Native scroll funkar överallt (även mobil utan Lenis)
  window.addEventListener("scroll", function () { onScroll(); }, { passive: true });

  // Lenis progress när den finns
  var lenisBound = false;
  function bindLenis() {
    if (lenisBound || !window._lenis) return;
    lenisBound = true;
    window._lenis.on("scroll", onScroll);
  }
  bindLenis();
  window.addEventListener("lenis:ready", bindLenis);

  // Init nu + load + page transitions
  if (document.readyState !== "loading") setup();
  else document.addEventListener("DOMContentLoaded", setup);
  window.addEventListener("load", setup);

  var pending;
  new MutationObserver(function (mutations) {
    var has = mutations.some(function (m) {
      return [].some.call(m.addedNodes, function (n) {
        return n.nodeType === 1 &&
          (n.tagName === "MARQUEE-COMPONENT" ||
           (n.querySelector && n.querySelector("marquee-component")));
      });
    });
    if (has) { clearTimeout(pending); pending = setTimeout(setup, 100); }
  }).observe(document.body, { childList: true, subtree: true });
})();